export function upsertById(array, newObj) {
  const existingItem = array.find(item => item.id === newObj.id);
  return existingItem
    ? array.map(item => (item.id === newObj.id ? { ...item, ...newObj } : item))
    : [...array, newObj];
}
